module.exports = __webpack_public_path__ + "files/bc5d1303b74c6b4fb4bb13e8ae52bb73.png";